"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ButtonPlayIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gatsby = require("gatsby");
var _utils = require("../../../utils/utils");
// Packages

// Utils

const {
  canHover
} = (0, _utils.getMediaQueries)();

// Styles
const ButtonIcon = _styledComponents.default.button.withConfig({
  displayName: "play__ButtonIcon",
  componentId: "sc-1nco8ez-0"
})(["background:transparent;border:none;cursor:pointer;svg{filter:", ";circle{fill:", ";transition:all 0.2s ease-in-out;}path{fill:", ";transition:all 0.2s ease-in-out;}opacity:", ";}&:active,&:focus{svg{circle{fill:", ";}path{fill:", ";}}}", ""], props => props.$circleDropShadow || "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))", props => props.$circleDefaultColor || undefined, props => props.$iconDefaultColor || undefined, props => props.$circleOpacity || 1, props => props.$circleActiveColor || undefined, props => props.$iconActiveColor || undefined, canHover`
    :hover {
      svg {
        circle {
          fill: ${props => props.$circleActiveColor || undefined};
        }
        path {
          fill: ${props => props.$iconActiveColor || undefined};
        }
      }
    }
  `);
function ButtonPlayIcon({
  circleDefaultColor,
  circleActiveColor,
  iconDefaultColor,
  iconActiveColor,
  circleDropShadow,
  circleOpacity,
  circleHeight,
  circleWidth,
  title,
  functions,
  linkAttributes
}) {
  return /*#__PURE__*/_react.default.createElement(ButtonIcon, Object.assign({}, functions, linkAttributes, {
    $circleDefaultColor: circleDefaultColor,
    $circleActiveColor: circleActiveColor,
    $iconDefaultColor: iconDefaultColor,
    $iconActiveColor: iconActiveColor,
    as: linkAttributes ? linkAttributes.href ? "a" : _gatsby.Link : "button",
    $circleOpacity: circleOpacity,
    $circleDropShadow: circleDropShadow,
    className: "play-button",
    title: title || "Play"
  }), /*#__PURE__*/_react.default.createElement("svg", {
    width: circleWidth,
    height: circleHeight,
    viewBox: "0 0 150 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter0_b_135_12142)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "75",
    cy: "75",
    r: "75",
    fill: "#012A53"
  })), /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter1_d_135_12142)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M99.75 71.1029C102.75 72.8349 102.75 77.1651 99.75 78.8971L66 98.3827C63 100.115 59.25 97.9497 59.25 94.4856V55.5144C59.25 52.0503 63 49.8853 66 51.6173L99.75 71.1029Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter0_b_135_12142",
    x: "-4.5",
    y: "-4.5",
    width: "159",
    height: "159",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: "2.25"
  }), /*#__PURE__*/_react.default.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_135_12142"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_135_12142",
    result: "shape"
  })), /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter1_d_135_12142",
    x: "11.25",
    y: "7.50769",
    width: "138.75",
    height: "143.985",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/_react.default.createElement("feOffset", {
    dy: "4.5"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "24"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_135_12142"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_135_12142",
    result: "shape"
  })))));
}
ButtonPlayIcon.propTypes = {
  /**
   * Sets height of icon circle
   */
  circleHeight: _propTypes.default.number,
  /**
   * Sets width of icon circle
   */
  circleWidth: _propTypes.default.number,
  /**
   * Sets default color of icon circle
   */
  circleDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon circle
   */
  circleActiveColor: _propTypes.default.string,
  /**
   * Sets drop shadow of icon circle
   */
  circleDropShadow: _propTypes.default.string,
  /**
   * Sets opacity of icon circle
   */
  circleOpacity: _propTypes.default.string,
  /**
   * Sets default color of icon
   */
  iconDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon
   */
  iconActiveColor: _propTypes.default.string,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string,
  /**
   * Button Functions, e.g. { onClick: () => {}}
   */
  functions: _propTypes.default.shape(),
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape()
};
ButtonPlayIcon.defaultProps = {
  circleHeight: 152,
  circleWidth: 150
};
ButtonPlayIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ButtonPlayIcon",
  "props": {
    "circleHeight": {
      "defaultValue": {
        "value": "152",
        "computed": false
      },
      "description": "Sets height of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "circleWidth": {
      "defaultValue": {
        "value": "150",
        "computed": false
      },
      "description": "Sets width of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "circleDefaultColor": {
      "description": "Sets default color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleActiveColor": {
      "description": "Sets active color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleDropShadow": {
      "description": "Sets drop shadow of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleOpacity": {
      "description": "Sets opacity of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconDefaultColor": {
      "description": "Sets default color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconActiveColor": {
      "description": "Sets active color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "functions": {
      "description": "Button Functions, e.g. { onClick: () => {}}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    }
  }
};